// eslint-disable-next-line import/prefer-default-export
export function onPageFocussed(callback) {
  let hidden;
  let visibilityChange;
  if (typeof document.hidden !== 'undefined') {
    // Opera 12.10 and Firefox 18 and later support
    hidden = 'hidden';
    visibilityChange = 'visibilitychange';
  } else if (typeof document.msHidden !== 'undefined') {
    hidden = 'msHidden';
    visibilityChange = 'msvisibilitychange';
  } else if (typeof document.webkitHidden !== 'undefined') {
    hidden = 'webkitHidden';
    visibilityChange = 'webkitvisibilitychange';
  }
  if (typeof document.addEventListener === 'undefined' || hidden === undefined) {
    console.warn("This browser does not support document visibility api, therefore it won't handle auto subscription");
  } else {
    const handleVisibilityChange = () => {
      if (!document[hidden]) {
        callback();
      }
    };
    console.debug('Adding document visibility Event listener');
    document.addEventListener(visibilityChange, handleVisibilityChange, false);
    return () => {
      console.debug('removing document visibility event listener');
      document.removeEventListener(visibilityChange, handleVisibilityChange);
    };
  }
  return () => {};
}
